import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod/v4";
import { PCMDashboard } from "../../../features/pcm";
import { isomorphicHttpClient } from "../../../httpClient";
import { verifyRoles } from "../../../utils/verifyRoles";

const pcmFiltersSearchParamsSchema = z.object({
  tenantId: z.string().default("").catch(""),
  startDate: z.iso.datetime().optional().catch(undefined),
  endDate: z.iso.datetime().optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/pcm/")({
  component: PCMDashboard,
  head: () => ({
    meta: [{ title: "PCM - Backoffice Detentora Iniciador" }],
  }),
  validateSearch: pcmFiltersSearchParamsSchema,
  search: {
    middlewares: [stripSearchParams(pcmFiltersSearchParamsSchema.parse({}))],
  },
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN", "ORG_OPERATOR"]),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData({
      queryKey: ["tenants"],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET("/v1/tenants");

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
